import { EnhancementReportStat } from "../../../models/enhancement/enhancement-report-stats"
import Top20Table from "./Top20Table"
import { Top20ByOnCallHoursTableData } from "./utils"
import { TableEmptyState } from "../TableEmptyState"

interface Top20EmployeesTableProps {
    data: EnhancementReportStat[]
    selectedRequestTypes?: string[] | null
}
  
function Top20ByOnCallHoursTable({ data, selectedRequestTypes }: Readonly<Top20EmployeesTableProps>) {
  // Only show data if no filter is selected or if "On Call" is selected
  const shouldShowData = !selectedRequestTypes || selectedRequestTypes.length === 0 || selectedRequestTypes.includes('On Call')
  
  // If filters are applied but "On Call" is not selected, show specific message
  if (selectedRequestTypes && selectedRequestTypes.length > 0 && !selectedRequestTypes.includes('On Call')) {
    return <TableEmptyState message="No data available - 'On Call' not selected in filters" />
  }
  
  const filteredData = shouldShowData ? data : []
  const tableData = Top20ByOnCallHoursTableData(filteredData, 'On Call')
  
  return <Top20Table data={tableData} />
}

export default Top20ByOnCallHoursTable
